import {
  Menu,
  MenuItem,
  Stack,
  Typography,
  useTheme
} from '@mui/material';
import { useAccessState } from 'modules/common';
import { menuUtil } from 'modules/common/layer00';
import { CustomIcon } from 'modules/components/layer00';
import { RemoveInstallationTypeModal } from 'modules/components/layer17';
import React, { useState } from 'react';



export type InstallationTypeMenuProps = menuUtil.IBaseMenuProps & {
  projectId: string;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: InstallationTypeMenuProps) => {
  const theme = useTheme();
  const [
    isVisible,
    setIsVisible
  ] = useState(false);
  const access = useAccessState('InstallationType');

  return (
    <>
      <Menu
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        id={props.id}
        open={props.open}
        anchorEl={props.anchorEl ?? null}
        onClose={() => props.handleClose()}
        onClick={(e) => {
          if (access.delete) {
            props.handleClick(e);
          }
        }}
      >

        <MenuItem
          disabled={
            access.delete
              ? false
              : true
          }
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setIsVisible(() => true);
          }}
        >
          <Stack
            // onClick={(e) => e.stopPropagation()}
            direction='row'
            columnGap='.5rem'
          >
            <CustomIcon.large.FC
              icon='DELETE'
              stroke={theme.palette.primary.main}
            />
            <Typography
              variant='menuItem'
            >
              Remove Selection Category
            </Typography>
          </Stack>
        </MenuItem>
      </Menu>
      {isVisible && (
        <RemoveInstallationTypeModal.FC
          id={props.id}
          projectId={props.projectId}
          handleClose={props.handleClose}
          isVisible={isVisible}
        />
      )}
    </>
  );
};
